var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.601,
    height: 73.598,
    viewBox: "0 0 59.601 73.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_66",
    "data-name": "Komponente 10 \\u2013 66",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "water-bottle",
    d: "M105.642,20.958a.923.923,0,0,0-.682-.3H84.454c.246-5.183-3-9.765-8.551-9.639V8.607h.65A1.539,1.539,0,0,0,78.089,7.07V2.925A2.928,2.928,0,0,0,75.164,0H66.211a2.928,2.928,0,0,0-2.925,2.925V7.07a1.538,1.538,0,0,0,1.537,1.537h.65v2.411a9.07,9.07,0,0,0-3.682.683.923.923,0,0,0,.742,1.69,6.244,6.244,0,0,1,2.526-.527H66.4a.923.923,0,0,0,.923-.923V8.607h6.739v3.334a.923.923,0,0,0,.923.923h1.337a6.3,6.3,0,0,1,6.3,6.3v1.332a1.546,1.546,0,0,1-1.543,1.545H60.306a1.546,1.546,0,0,1-1.543-1.545V19.163a6.272,6.272,0,0,1,1.059-3.5.923.923,0,0,0-1.534-1.026,8.111,8.111,0,0,0-1.37,4.524v1.332a3.382,3.382,0,0,0,1.069,2.468,3.38,3.38,0,0,0-1.069,2.467v8.195A3.391,3.391,0,0,0,57.984,36.1a3.462,3.462,0,0,0-.044,5.026A3.462,3.462,0,0,0,58,46.158a4.183,4.183,0,0,0-1.079,3.064v5.632A8.152,8.152,0,0,0,65.058,63H76.317a8.137,8.137,0,0,0,6.733-3.572l.006.064A3.851,3.851,0,0,0,86.908,63h11.6a3.851,3.851,0,0,0,3.852-3.508l.288-3.1a.923.923,0,0,0-1.838-.171l-.288,3.1a2.013,2.013,0,0,1-2.014,1.834h-11.6a2.013,2.013,0,0,1-2.014-1.834l-.424-4.553c0-.028-.007-.055-.012-.082V49.222A4.209,4.209,0,0,0,83.4,46.185a3.462,3.462,0,0,0,.085-5.064,3.461,3.461,0,0,0-.072-5.051,3.391,3.391,0,0,0,1.041-2.446v-.385h18.489l-1.705,18.312a.923.923,0,0,0,1.838.171l2.8-30.058a.924.924,0,0,0-.237-.707Zm-40.51-14.2V2.925a1.08,1.08,0,0,1,1.079-1.079h8.953a1.081,1.081,0,0,1,1.079,1.079V6.761ZM81.068,23.885a1.546,1.546,0,0,1,1.544,1.544v8.195a1.558,1.558,0,0,1-1.556,1.556H60.319a1.558,1.558,0,0,1-1.556-1.556V25.43a1.546,1.546,0,0,1,1.544-1.544Zm1.544,30.969a6.3,6.3,0,0,1-6.3,6.3H65.058a6.3,6.3,0,0,1-6.3-6.3V49.223a2.223,2.223,0,0,1,.724-1.908,1.575,1.575,0,0,1,.755-.285H75.459a.923.923,0,0,0,0-1.846H60.222a1.571,1.571,0,0,1,0-3.139.923.923,0,0,0,0-1.846,1.571,1.571,0,0,1,0-3.139H81.207a1.571,1.571,0,0,1,0,3.139H65.279a.923.923,0,0,0,0,1.846H81.207a1.571,1.571,0,0,1,0,3.139.924.924,0,0,0-.03,1.845c.059,0,1.435.07,1.435,2.194Zm1.846-23.461V25.43a3.38,3.38,0,0,0-1.069-2.467,3.414,3.414,0,0,0,.408-.46h20.149l-.828,8.891Z",
    transform: "translate(-56.881 0)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35458",
    "data-name": "Gruppe 35458",
    transform: "translate(-334.499 -2887.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#a5b5af",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-database",
    "data-name": "Icon metro-database",
    d: "M7.571,1.928c-2.761,0-5,.7-5,1.563v1.25c0,.863,2.239,1.562,5,1.562s5-.7,5-1.562V3.491C12.571,2.628,10.332,1.928,7.571,1.928Zm0,5.313c-2.761,0-5-.7-5-1.562V7.553c0,.863,2.239,1.563,5,1.563s5-.7,5-1.563V5.678C12.571,6.541,10.332,7.241,7.571,7.241Zm0,2.812c-2.761,0-5-.7-5-1.562v1.875c0,.863,2.239,1.563,5,1.563s5-.7,5-1.562V8.491C12.571,9.353,10.332,10.053,7.571,10.053Z",
    transform: "translate(371.429 2939.072)",
    fill: "#a5b5af"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.4c20aea0a546a1047e779dd79400b155.svg";
export { ForwardRef as ReactComponent };